import React from 'react';
import styles from './StepsBar.module.scss';
import circleIcon from '../../../assets/Imagess/check-circle.svg';

function StepsBar({ step, setStep }) {
  const handleOnClick = (index) => {
    if (index < step) {
      setStep(index);
    }
  };
  return (
    <div className={styles['steps-bar']}>
      <div
        className={styles['bar']}
        style={{
          backgroundColor: 1 === step ? '#0DA06E' : '#01684A',
          color: step === 1 ? '#0DA06E' : '#01684A',
          cursor: 1 <= step ? 'pointer' : 'default',
        }}
        onClick={() => handleOnClick(1)}
      >
        {step > 1 && <img src={circleIcon} />}
        <p>ملخص</p>
      </div>
      <div
        className={styles['bar']}
        style={{
          backgroundColor:
            2 === step ? '#0DA06E' : 3 === step ? '#01684A' : '#A6D2AD',
          color: step === 2 ? '#0DA06E' : step === 3 ? '#01684A' : '#A6D2AD',
          cursor: 2 <= step ? 'pointer' : 'default',
        }}
        onClick={() => handleOnClick(2)}
      >
        {step > 2 && <img src={circleIcon} />}
        <p>مقرر</p>
      </div>
      <div
        className={styles['bar']}
        style={{
          backgroundColor: 3 === step ? '#0DA06E' : '#BFE3C5',
          cursor: 3 <= step ? 'pointer' : 'default',
        }}
        onClick={() => handleOnClick(3)}
      >
        {step > 3 && <img src={circleIcon} />}
        <p>قبول</p>
      </div>
    </div>
  );
}

export default StepsBar;
